import { postCouponReceive } from '@musinsa/apis-curator';
import {
  lazyPipe,
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';
import {
  type ReceiveCouponServiceRequest,
  ReceiveCouponServiceRequestSchema,
  type ReceiveCouponServiceResponse,
  ReceiveCouponServiceResponseSchema,
} from './receiveCoupon.dto';

const transformApiResponseToServiceResponse = async (
  request: ReceiveCouponServiceRequest,
): Promise<ReceiveCouponServiceResponse> => {
  const response = await postCouponReceive({
    shopTitle: request.shopTitle,
    couponNo: request.couponNo,
  });

  return {
    couponNo: response.data.couponNo,
  };
};

export const receiveCouponService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(ReceiveCouponServiceRequestSchema),
    transformApiResponseToServiceResponse,
    validateServiceResponse(ReceiveCouponServiceResponseSchema),
  ),
);
